import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import { useNavigate } from "react-router-dom";
import { ReactComponent as HeartIcon } from "../assets/heart.svg";

const FinalVideoScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "You're the one";
  }, []);

  const VIDEO_ID = "0DtW5HX3MpM";
  const [showPlayer, setShowPlayer] = useState(false);
  const [posterError, setPosterError] = useState(false);

  const posterUrl = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;

  const opts = {
    playerVars: { autoplay: 1, rel: 0 },
  };

  return (
    <div className="center-viewport">
      <div className="container video-wrapper">
      <div className="enter-up" style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", gap: 12 }}>
        <button className="back-button" onClick={() => navigate("/video")} aria-label="Back to previous video">Back</button>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <HeartIcon style={{ width: 22, height: 22, color: "var(--color-rose)" }} aria-hidden />
          <div style={{ fontSize: 18, fontWeight: 600 }}>A look into the past</div>
        </div>
      </div>

      <div style={{ marginTop: 10 }}>
        <div className="video-aspect enter-up">
          {!showPlayer ? (
            posterError ? (
              <div className="video-poster-fallback" role="button" tabIndex={0} onClick={() => setShowPlayer(true)} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowPlayer(true); }} aria-label="Play video">
                <div style={{ textAlign: 'center' }}>
                  <div style={{ marginBottom: 8 }}>Poster not available</div>
                  <div style={{ opacity: 0.9 }} className="play-circle" aria-hidden>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                </div>
              </div>
            ) : (
              <div
                role="button"
                tabIndex={0}
                className="play-overlay"
                onClick={() => setShowPlayer(true)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setShowPlayer(true); } }}
                aria-label="Play video"
              >
                <img
                  className="video-poster"
                  src={posterUrl}
                  alt="Video thumbnail"
                  onError={() => { console.warn('Video thumbnail failed to load:', posterUrl); setPosterError(true); }}
                />
                <div className="play-circle" aria-hidden>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </div>
            )
          ) : (
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', backgroundColor: '#000' }}>
              <YouTube
                videoId={VIDEO_ID}
                opts={opts}
                onError={(e) => {
                  const errorCodes = {
                    2: 'Invalid parameter',
                    5: 'HTML5 player error',
                    100: 'Video not found (removed or private)',
                    101: 'Video cannot be played embedded',
                    150: 'Same as 151 (embedding not allowed)',
                  };
                  console.error(`YouTube Error Code: ${e.data}`, errorCodes[e.data] || 'Unknown error');
                  console.error('Full error object:', e);
                  console.log('Video ID being played:', VIDEO_ID);
                  setPosterError(true);
                }}
                containerClassName="youtube-container"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              />
              {posterError && showPlayer && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: 'rgba(0, 0, 0, 0.7)',
                    zIndex: 10,
                    color: 'white',
                    textAlign: 'center',
                  }}
                >
                  <p style={{ marginBottom: 16, fontSize: 16 }}>Video unavailable on this platform</p>
                  <a
                    href={`https://www.youtube.com/watch?v=${VIDEO_ID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding: '10px 20px',
                      background: 'var(--color-rose)',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '4px',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    Watch on YouTube
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="video-meta enter-up">
        <p style={{ marginTop: 12 }}>Enjoy 💖</p>
      </div>
      </div>
    </div>
  );
};

export default FinalVideoScreen;
